export default {
      id: "digitalDesign-usage",
      viewBox: "0 0 100 53",
      url: "assets/" + "sprite.svg#digitalDesign-usage",
      toString: function () {
        return this.url;
      }
    }